export default __webpack_public_path__ + "static/media/billy-on-piggy-bank.971cf423.png";